import * as React from 'react';
import { Link } from 'react-router-dom';

require('./toolbar-analyse.scss');

export interface ToolbarAnalyseProps {
  logoPath: string;
  text: string;
  newSearchUrl?: string;
}

export const ToolbarAnalyse: React.FC<ToolbarAnalyseProps> = ({ text, logoPath, newSearchUrl }) => {
  const searchUrl = newSearchUrl || '/';
  return (
    <div className="l-toolbar-analyse">
      <Link to={searchUrl}>
        <img src={logoPath} alt="" className="l-toolbar-analyse__logo" />
      </Link>
      <div className="l-toolbar-analyse__text">
        <span>{text}</span>
      </div>
      <div className="l-toolbar-analyse__link">
        <Link to={searchUrl}>New Search</Link>
      </div>
    </div>
  );
};
